module.exports = __webpack_public_path__ + "img/privacy_policy.185cbb7c.svg";